import { render, staticRenderFns } from "./SyncLayoutToggle.vue?vue&type=template&id=7f3a6c79&scoped=true"
import script from "./SyncLayoutToggle.vue?vue&type=script&lang=js"
export * from "./SyncLayoutToggle.vue?vue&type=script&lang=js"
import style0 from "./SyncLayoutToggle.vue?vue&type=style&index=0&id=7f3a6c79&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3a6c79",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f3a6c79')) {
      api.createRecord('7f3a6c79', component.options)
    } else {
      api.reload('7f3a6c79', component.options)
    }
    module.hot.accept("./SyncLayoutToggle.vue?vue&type=template&id=7f3a6c79&scoped=true", function () {
      api.rerender('7f3a6c79', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/SyncLayoutToggle.vue"
export default component.exports